import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import FacebookLogin from "react-facebook-login";

import SVG from "../../../../components/SVG";
import {
  Button,
  LoadingIndicator,
  Select
} from "../../../../components/simple";

import { PLATFORMS } from "../platforms";
import Api from "../../../../api";

import styles from "../push-modal.module.scss";
import LabelForRow from "../../../../components/forms/LabelForRow";

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

// eslint-disable-next-line react/prefer-stateless-function
const Facebook = ({
  // audienceType,
  // editAudienceHandler,
  selectedPlatform,
  fbData,
  responseFacebook,
  handlePushToPlatform
  // allowEdit
  // handleAdsetIdChange,
  // adsetId
}) => {
  const [fbIsAuthorized, setFbIsAuthorized] = useState(false);

  // useEffect(() => {
  //   const checkFbIsAuthorized = async () => {
  //     await Api.platforms.fb
  //       .isAuthorized()
  //       .then((res) => {
  //         if (res?.valid) {
  //           setFbIsAuthorized(true);
  //         } else {
  //           setFbIsAuthorized(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   };

  //   checkFbIsAuthorized();
  // }, []);

  const [selectedData, setSelectedData] = useState({
    adAccountId: "",
    campaignId: "",
    adSetId: ""
  });

  const [responseData, setResponseData] = useState({
    adAccounts: [],
    campaigns: [],
    adSets: []
  });

  const [responseErrorMessage, setResponseErrorMessage] = useState({
    adAccounts: "",
    campaigns: "",
    adSets: ""
  });

  const prevSelectedData = usePrevious(selectedData);

  // const [isAuthorized, setIsAuthorized] = useState(false);

  const platforms = useSelector(state => state.platforms);

  useEffect(() => {
    if (!fbData?.accessToken) return;

    const checkFb = async () => {
      try {
        await Api.platforms.fb.isAuthorized();
        await Api.platforms.fb.setAccessToken({
          data: {
            accessToken: fbData.accessToken,
            dataAccessExpirationTime: fbData.data_access_expiration_time
          }
        });

        setFbIsAuthorized(true);
      } catch (err) {
        console.log(err);
        setFbIsAuthorized(false);
      }
    };

    checkFb();
  }, [fbData]);

  useEffect(() => {
    // if (!isAuthorized || responseErrorMessage.adAccounts) return;
    if (!fbIsAuthorized || responseErrorMessage.adAccounts) return;

    const getAdAccounts = async () => {
      try {
        const adAccounts = await Api.platforms.fb.getAdAccounts();

        if (adAccounts.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            adAccounts: adAccounts.message
          }));

          setResponseData({
            adAccounts: [],
            campaigns: [],
            adSets: []
          });

          return;
        }

        setResponseData({
          adAccounts,
          campaigns: [],
          adSets: []
        });
      } catch (error) {
        console.log(error);
      }
    };

    const getCampaigns = async adAccountId => {
      setSelectedData(prevData => ({
        ...prevData,
        campaignId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        campaigns: ""
      }));

      try {
        const campaigns = await Api.platforms.fb.getCampaigns({
          adAccountId
        });
        if (campaigns.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            campaigns: campaigns.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            campaigns: [],
            adSets: []
          }));

          return;
        }

        setResponseData(prevData => ({
          ...prevData,
          campaigns,
          adSets: []
        }));
      } catch (error) {
        console.log(error);
      }
    };

    const getAdSets = async campaignId => {
      setSelectedData(prevData => ({
        ...prevData,
        adSetId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        adSets: ""
      }));

      try {
        const adSets = await Api.platforms.fb.getAdSets({
          campaignId
        });

        if (adSets.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            adSets: adSets.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            adSets: []
          }));

          return;
        }

        setResponseData(prevData => ({
          ...prevData,
          adSets
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (!responseData.adAccounts.length) getAdAccounts();

    if (
      prevSelectedData.adAccountId !== selectedData.adAccountId &&
      selectedData.adAccountId
    ) {
      getCampaigns(selectedData.adAccountId);
    }

    if (
      prevSelectedData.campaignId !== selectedData.campaignId &&
      selectedData.campaignId
    ) {
      getAdSets(selectedData.campaignId);
    }
  }, [
    // isAuthorized,
    fbIsAuthorized,
    selectedData,
    responseData,
    prevSelectedData,
    responseErrorMessage
  ]);

  const handleSelectChange = (name, value) => {
    setSelectedData(prevData => ({
      ...prevData,
      [`${name}Id`]: value
    }));
  };

  const onSubmitHandler = e => {
    e.preventDefault();

    if (selectedData.adSetId)
      handlePushToPlatform(PLATFORMS.facebook, {
        adsetId: selectedData.adSetId
      });
  };

  return (
    <>
      <div
        className={` ${styles["fb-signin"]} ${
          selectedPlatform === "facebook" ? styles["slide-from-right"] : ""
        }`}
      >
        {!fbData?.accessToken ? (
          <div className={styles["connect-account"]}>Sign In</div>
        ) : null}
        {selectedPlatform === PLATFORMS.facebook ? (
          <>
            {fbData?.accessToken ? (
              <div className={styles["fb-authorized-profile"]}>
                <img src={fbData?.picture?.data?.url} alt="avatar" />
                <span>{fbData?.name}</span>
                <SVG.Tick2 className={styles["fb-authorized-icon"]} />
              </div>
            ) : null}
            {!fbData?.accessToken ? (
              <>
                <FacebookLogin
                  className={styles["platform-signin-button"]}
                  appId={process.env.REACT_APP_FB_APP_ID}
                  fields="name,email,picture"
                  scope="public_profile,ads_management,ads_read"
                  cookie
                  callback={responseFacebook}
                  cssClass={styles["platform-signin-button"]}
                  textButton="Sign in to Facebook Business"
                  render={renderProps => (
                    <Button onClick={renderProps.onClick}></Button>
                  )}
                />
              </>
            ) : null}
            <div className={styles["platform-description"]}>
              {/* {!fbData?.accessToken ? ( */}
              {/*  <> */}
              {/*    <SVG.Lock2 */}
              {/*      className={styles["lock-icon"]} */}
              {/*      width={25} */}
              {/*      height={20} */}
              {/*      fill="#A2B2CF" */}
              {/*    /> */}
              {/*    Facebook Groups is a secure partner with Zapier. Your */}
              {/*    credentials are encrypted & can be removed at any time. */}
              {/*  </> */}
              {/* ) : null} */}
            </div>

            {fbData?.accessToken ? (
              <>
                <form onSubmit={onSubmitHandler}>
                  {!responseErrorMessage.adAccounts ? (
                    <div>
                      <LabelForRow
                        label="Choose the campaign you want to activate on"
                        title="Pick Ad Account"
                      />
                      <Select
                        isSearchable
                        selectForThePushForm
                        label="Ad Account"
                        placeholder="Ad Account"
                        optionLabel="name"
                        optionValue="id"
                        options={responseData.adAccounts}
                        name="adAccount"
                        handleChange={handleSelectChange}
                        isDisabled={!responseData.adAccounts.length}
                        required
                      />
                    </div>
                  ) : (
                    <p
                      className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                    >
                      {responseErrorMessage.adAccounts}
                    </p>
                  )}

                  {!responseErrorMessage.campaigns ? (
                    <div>
                      <LabelForRow
                        label="Choose the adset the audience needs to be added to"
                        title="Pick Campaign"
                      />
                      <Select
                        isSearchable
                        selectForThePushForm
                        label="Campaign"
                        placeholder="Campaign"
                        optionLabel="name"
                        optionValue="id"
                        options={responseData.campaigns}
                        name="campaign"
                        handleChange={handleSelectChange}
                        isDisabled={!responseData.campaigns.length}
                        required
                      />
                    </div>
                  ) : (
                    <p
                      className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                    >
                      {responseErrorMessage.campaigns}
                    </p>
                  )}

                  {!responseErrorMessage.adSets ? (
                    <div>
                      <LabelForRow
                        label="Choose the adset the audience needs to be added to"
                        title="Pick Adset"
                      />
                      <Select
                        isSearchable
                        selectForThePushForm
                        label="AdSet"
                        placeholder="Adset Name"
                        optionLabel="name"
                        optionValue="id"
                        options={responseData.adSets}
                        name="adSet"
                        handleChange={handleSelectChange}
                        isDisabled={!responseData.adSets.length}
                        required
                      />
                    </div>
                  ) : (
                    <p
                      className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                    >
                      {responseErrorMessage.adSets}
                    </p>
                  )}

                  {platforms?.isLoading ? (
                    <div
                      style={{ marginTop: "32px" }}
                      className="mt-4 d-flex justify-content-center"
                    >
                      <LoadingIndicator />
                    </div>
                  ) : (
                    <div className={styles.button_container}>
                      <Button
                        disabled={!selectedData.adSetId}
                        type="submit"
                        className={styles["push-audience-btn"]}
                      >
                        <span>Push</span>
                      </Button>
                      {/* {audienceType === "audience" && allowEdit && ( */}
                      {/*  <Button */}
                      {/*    type="button" */}
                      {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
                      {/*    onClick={editAudienceHandler} */}
                      {/*  > */}
                      {/*    <span>Edit audience</span> */}
                      {/*  </Button> */}
                      {/* )} */}
                    </div>
                  )}
                </form>
              </>
            ) : null}
          </>
        ) : null}
      </div>
    </>
  );
};

Facebook.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  selectedPlatform: PropTypes.string,
  fbData: PropTypes.shape({
    picture: PropTypes.shape({
      data: PropTypes.shape({ url: PropTypes.string })
    }),
    name: PropTypes.string,
    accessToken: PropTypes.string,
    data_access_expiration_time: PropTypes.number
  }),
  responseFacebook: PropTypes.func.isRequired,
  handlePushToPlatform: PropTypes.func.isRequired
  // editAudienceHandler: PropTypes.func.isRequired,
  // allowEdit: PropTypes.bool.isRequired
};

Facebook.defaultProps = {
  selectedPlatform: "",
  fbData: {
    picture: {
      data: { url: "" }
    },
    name: ""
  }
};

export default Facebook;
